// src/App.js
import React, { useEffect, useState } from 'react';
import { CssBaseline, Box } from '@mui/material';
import Navbar from './components/Navbar';
import Sidebar from './components/Sidebar';
import { useSelector } from 'react-redux';
import Routing from './routes/Routing';
import theme from './configs/theme';
import { ThemeProvider } from '@mui/material/styles';

// Width of the sidebar when open

const App = () => {


  const lang = useSelector((state) => state.authReducer.lang);


  useEffect(() => {
    const color = localStorage.getItem('appColor');
    if (!color) localStorage.setItem('appColor', 'rgba(0, 36, 70)')
  }, [])

  return (
    <div dir={lang == 'en' ? 'ltr' : "rtl"}>
      <ThemeProvider theme={theme}>

        <CssBaseline />
        {/* Navbar and Sidebar */}
        <Routing />
      </ThemeProvider>

    </div>
  );
};

export default App;
